// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"14cd67c3","239":"4d6c1015","453":"934d9d57","455":"5882f39c"}[chunkId] + ".chunk.js";
};